import React from "react";
import Spacing from "../../Spacing";
import SectionHeadingStyle3 from "../../SectionHeading/SectionHeadingStyle3";
import { pageTitle } from "../../../helpers/PageTitle";
export default function Success() {
  pageTitle("Success");
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Booking Success"
        subTitle="Home"
        variant="text-center"
        href="/shop"
      />
      <Spacing lg="125" md="60" />
      <div className="container">
        <p className="m-0 text-center">
          Thank you! Your Booking has been received.
        </p>
        <div className="cs_height_95 cs_height_lg_50" />
        <ul className="cs_order-summery">
          <li>
            <p>Order Number:</p>
            <h3>0001</h3>
          </li>
          <li>
            <p>Date:</p>
            <h3>Thursday, January 30, 2025</h3>
          </li>
          <li>
            <p>Total:</p>
            <h3>Rs. 9,000</h3>
          </li>
          <li>
            <p>Payment method:</p>
            <h3>Pay on Club</h3>
          </li>
        </ul>
        <div className="cs_height_50 cs_height_lg_30" />
        <div className="cs_shop-card">
          <h2>Booking details</h2>
          <table className="border-bottom-0">
            <tbody>
              <tr className="cs_semi_bold">
                <td>Date</td>
                <td className="text-end">Thursday, January 30, 2025</td>
              </tr>
              <tr className="cs_semi_bold">
                <td>Sport</td>
                <td className="text-end">Padel</td>
              </tr>
              <tr>
                <td>Court</td>
                <td className="text-end">Padel Court 3</td>
              </tr>
              <tr>
                <td>Time</td>
                <td className="text-end">11:00</td>
              </tr>
              <tr>
                <td>Duration</td>
                <td className="text-end">1 hour</td>
              </tr>

              <tr>
                <td className="cs_semi_bold">Payment method</td>
                <td className="text-end">Cash on delivery</td>
              </tr>
              <tr className="cs_semi_bold">
                <td className="pb-0">Total</td>
                <td className="text-end pb-0">Rs. 9,000</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <Spacing lg="150" md="80" />
    </>
  );
}
